import React from 'react';
import PageHeader from '../ui/PageHeader';
import StepCard, { LinkTile } from '../ui/StepCard';
import ContractRow from '../ui/ContractRow';
import Seo from '../ui/Seo';
import { CONTRACTS } from '../../data/site';
import maiadao from '../../assets/images/maiadao.jpg';

const EvmBuyPage = () => (
  <main className="wrap">
    <Seo
      title="Buy $BOOP from any EVM chain"
      description="Buy $BOOP from Ethereum, Base, OP and more using the HermesOmnichain swap tool by MaiaDAO."
      path="/buy/evm"
    />
    <PageHeader
      back={{ to: '/buy', label: 'Back to options' }}
      eyebrow="🌉 ANY EVM CHAIN"
      title="Buy $BOOP with"
      highlight="HermesOmnichain"
      sub="Follow these steps to buy BOOP from any EVM chain using the HermesOmnichain swap tool."
    />

    <div className="grid items-start gap-6 pt-7 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] lg:gap-10 lg:pt-12">
      <ol className="grid gap-4 lg:gap-5">
        <StepCard n={1} title="Load the HermesOmnichain swap tool">
          <p>Navigate to the HermesOmnichain app page, powered by MaiaDAO:</p>
          <LinkTile href="https://app.maiadao.io/" title="Launch HermesOmnichain" sub="app.maiadao.io" />
        </StepCard>
        <StepCard n={2} title="Connect your wallet">
          <ul className="grid list-disc gap-1.5 pl-5">
            <li>Any EVM compatible wallet will work</li>
            <li>Make sure the wallet supports your source network and the Arbitrum network</li>
            <li>Make sure you have some ETH in your source wallet to execute the trade</li>
            <li>If not, withdraw some ETH through a CEX, or buy directly through your wallet&apos;s interface (if supported)</li>
          </ul>
        </StepCard>
        <StepCard n={3} title="Set up your trade">
          <p>
            <b>FROM:</b> select your source network and your source currency
          </p>
          <p>
            <b>TO:</b> select Arbitrum as the network and search for BOOP as the currency
          </p>
        </StepCard>
        <StepCard n={4} title="Execute the trade">
          <ul className="grid list-disc gap-1.5 pl-5">
            <li>Once the platform gives you a quote, execute the trade</li>
            <li>The platform handles all bridging and swapping transactions for you</li>
            <li>BOOP is delivered to the same wallet address as the source wallet, on the Arbitrum network</li>
          </ul>
        </StepCard>

        <li className="card !bg-sun">
          <h3 className="text-xl font-bold">BOOP contract address (Arbitrum)</h3>
          <p className="mb-3 text-sm font-medium">Always verify the contract address before making any transaction.</p>
          <ContractRow chain={CONTRACTS.arbitrum} showExplorer />
        </li>
      </ol>

      <aside className="lg:sticky lg:top-24">
        <div className="card">
          <h3 className="text-xl font-bold">Example interface</h3>
          <p className="section-sub">This is how the MaiaDAO interface looks.</p>
          <div className="art">
            <img src={maiadao} alt="MaiaDAO HermesOmnichain interface" className="h-auto w-full" loading="lazy" />
          </div>
        </div>
      </aside>
    </div>
  </main>
);

export default EvmBuyPage;
